import React from 'react';
import { observer } from 'mobx-react';

import { ParamsHelper } from '../../../helpers/ParamsHelper';
import { Separator } from '../separator';
import { VideosStore } from '../stores/VideosStore';
import { ProductStore } from '../stores/ProductStore';
import styles from './VideosSection.css';

const createYoutubeEmbedLink = (youtubeId) => {
  const url = `https://www.youtube.com/embed/${youtubeId}`;
  // For param explanation, visit https://developers.google.com/youtube/player_parameters#Parameters
  const params = {
    disablekb: 1,
    hl: 'es',
    modestbranding: 1,
    rel: 0,
  };
  return `${url}${ParamsHelper.createQueryParams(params)}`;
};

const VideosSection = observer(class VideosSection extends React.Component {
  componentDidMount() {
    VideosStore.fetchVideos(ProductStore.product.id);
  }

  render() {
    if (!VideosStore.videos || !VideosStore.videos.length) {
      return null;
    }
    const { videos } = VideosStore;
    return (
      <section className={styles.container}>
        <h2 className={styles.title}>
          Videos
        </h2>
        <div className={styles.videoList}>
          {videos.map(video => (
            <iframe
              allowFullScreen
              className={styles.video}
              height="190"
              key={video.youtubeId}
              src={createYoutubeEmbedLink(video.youtubeId)}
              title={video.youtubeId}
              width="340"
            />
          ))}
        </div>
        <Separator />
      </section>
    );
  }
});

export { VideosSection };



// WEBPACK FOOTER //
// ./src/pages/product-detail/videos-section/VideosSection.jsx